import { serialize } from '@ungap/structured-clone';
import { GetAllMuscles } from '../../../../anatomy/get-all-muscles.js';
import { RgTraverse } from '../../../../utils/rg-traverse.js';
import { rgObjectToDto } from '../../rg-object-to-dto.js';

const buildingToDto = (building, top, versions) => {
    // remove parent relationship to ease the serializer
    GetAllMuscles(building.data.anatomy).forEach(muscle => {
        muscle.gFUnits.forEach(muscleUnit => {
            RgTraverse(muscleUnit, rgObj => {
                rgObj.parent = undefined;
            });
        });
    });
    const muscles = GetAllMuscles(building.data.anatomy);
    const musclesUnits = muscles.map(m => m.gFUnits);
    const musclesUnitsCopy = musclesUnits.map(units => units.map(u => ({ ...u, data: { ...u.data } })));
    /** building children copy ready to become DTO */
    const children = building.children.slice();
    /** original building units */
    const units = new Map(children.map(c => [c.uuid, c]));
    /** muscle units temporarily added to building children */
    const tempUnits = new Map();
    // replace units with their uuids
    for (const muscle of muscles) {
        muscle.gFUnitsIds = muscle.gFUnits.map(u => u.uuid);
        muscle.gFUnits = [];
    }
    // add units as building children (we will remove them on dto to raw)
    for (const muscleUnits of musclesUnitsCopy) {
        for (const unit of muscleUnits) {
            if (units.has(unit.uuid))
                continue;
            unit.data.dtoMuscleUnit = true;
            // add them as building children so they use the usual DTO strategy
            children.push(unit);
            tempUnits.set(unit.uuid, unit);
        }
    }
    const data = {
        ...building.data,
        anatomy: serialize(building.data.anatomy)
    };
    // revert back muscles to their original form
    for (let i = 0; i < muscles.length; i++) {
        muscles[i].gFUnits = musclesUnits[i];
        delete muscles[i].gFUnitsIds;
    }
    return rgObjectToDto({ rgObj: { ...building, children }, top, partial: { data }, versions });
};

export { buildingToDto };
//# sourceMappingURL=building-to-dto.js.map
